import { StyleSheet } from 'react-native';

import { isBigScreen } from '../../media-query';

const paddingHorizontal = isBigScreen() ? 62 : 16;

export default StyleSheet.create({
  container: {
    flex: 1,
    marginTop: 32,
    marginBottom: 48,
    paddingHorizontal,
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginHorizontal: 0,
    marginBottom: 16,
  },
});
